import {Cloneable} from "@/common/Cloneable";
import {alias, createModelSchema, custom, deserialize, serialize, SKIP, list} from "serializr";
import {Schema} from "@/common/Schema";
import {CurenciesModel} from "@/modules/mprofiles/models/props/user_profile/CurrenciesModel";

export class UserProfile extends Cloneable {

    static schema() {
        return custom(
            (v) => {
                return v && !v.empty() ? serialize(UserProfile, v) : SKIP;
            },
            (v) => {
                return deserialize(UserProfile, v);
            }
        );
    }

    constructor() {
        super();
        this._level = null;
        this._tutorial_step = false;
        this._gameflow_step = null;
        this._currencies = [];
        this._hints = [];
    }

    get tutorial_step() {
        return this._tutorial_step;
    }
    set tutorial_step(value) {
        this._tutorial_step = value;
    }

    get gameflow_step() {
        return this._gameflow_step;
    }
    set gameflow_step(value) {
        this._gameflow_step = value;
    }

    get level() {
        return this._level;
    }
    set level(value) {
        this._level = value;
    }

    get currencies() {
        return this._currencies;
    }
    set currencies(value) {
        this._currencies= value;
    }

    get hints() {
        return this._hints;
    }
    set hints(value) {
        this._hints = value;
    }

    clone(target = undefined) {
        if (!target) {
            return super.clone(new UserProfile());
        } else if (target instanceof UserProfile) {
            return super.clone(target);
        } else {
            console.assert(false);
            return undefined;
        }
    }
}

createModelSchema(UserProfile, {
    _tutorial_step: alias("tutorial_step", Schema.primitive()),
    _gameflow_step: alias("gameflow_step", Schema.primitive()),
    _level: alias("level", Schema.primitive()),
    _currencies: alias("currencies", list(CurenciesModel.schema())),
    _hints: alias("hints", list(Schema.primitive())),
});
